export default "__VITE_ASSET__r396lE9j__"